
<!-- Ce template n'est utilisé que pour saisir le Pied de page -->
<div class="Accueil">
  <div class="hint">[Accueil Page]</div>
  <h1>{{ content.title || metadata['@name'] }}</h1>
</div>
